import { Injectable } from '@angular/core';
import { AuthService } from '@shared/modules/auth/services/auth.service';
import { environment } from '@environments/environment';

@Injectable()
export class AppInitializer {
  constructor(private authService: AuthService) {}

  async load(): Promise<boolean> {
    sessionStorage.clear();

    await this.setIcons();

    return this.authService.checkAuth();
  }

  private setIcons(): Promise<void> {
    return new Promise((resolve) => {
      const iconIds = ['whc-icon-main', 'whc-icon-ie'];

      iconIds.forEach((id) => {
        const img = document.getElementById(id) as HTMLImageElement;
        if (img) {
          img.src = environment.whcIconPath;
          img.style.visibility = 'visible';
        }
      });

      resolve();
    });
  }
}
